import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("h4", null, "Gestione task", -1);
const _hoisted_2 = { class: "form-group" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("label", null, "Aggiorna stato", -1);
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, "Seleziona", -1);
const _hoisted_6 = ["value"];
const _hoisted_7 = { class: "statiBox" };
const _hoisted_8 = { class: "label" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("h4", null, "Modifiche richieste", -1);
const _hoisted_11 = {
    key: 0,
    class: "modificheRichieste"
};
const _hoisted_12 = { key: 0 };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("p", null, "Nessuna modifica richiesta", -1);
const _hoisted_14 = { key: 1 };
const _hoisted_15 = { class: "form-group" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createElementVNode("b", null, "Inserisci una descrizione della modifica richiesta")
], -1);
const _hoisted_17 = [".value"];
const _hoisted_18 = { class: "text-right" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("h4", null, "Consegna", -1);
const _hoisted_21 = { class: "d-flex justify-content-between" };
const _hoisted_22 = { class: "form-group" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("label", null, "Mostra allegati al cliente", -1);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("h4", null, "Spostamento", -1);
const _hoisted_26 = { class: "form-group" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("label", null, "Nuovo proprietario del task", -1);
const _hoisted_28 = ["value"];
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_30 = { class: "text-right mt-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    const _directive_label = _resolveDirective("label");
    return (_openBlock(), _createElementBlock("div", null, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("select", {
                    class: "form-control w-75 mr-2",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.newStato) = $event))
                }, [
                    _hoisted_5,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statiTask, (item, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                            key: i,
                            value: item
                        }, _toDisplayString(item), 9, _hoisted_6));
                    }), 128))
                ], 512), [
                    [_vModelSelect, _ctx.newStato]
                ]),
                (_ctx.updating)
                    ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-blue",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.updateStatus && _ctx.updateStatus(...args)))
                    }, " Aggiorna stato "))
            ])
        ]),
        _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.stateHistory, (item, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                        class: "mb-1",
                        key: i
                    }, [
                        _createTextVNode(_toDisplayString(_ctx.$filters.date(item.date, null, true)) + " - ", 1),
                        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_8, [
                            _createTextVNode(_toDisplayString(item.text), 1)
                        ])), [
                            [_directive_label, item.text]
                        ])
                    ]));
                }), 128))
            ])
        ]),
        _hoisted_9,
        _createElementVNode("button", {
            type: "button",
            class: "float-right btn btn-blue",
            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.showAddModifica = !_ctx.showAddModifica))
        }, _toDisplayString(_ctx.showAddModifica ? 'Annulla' : 'Aggiungi richiesta'), 1),
        _hoisted_10,
        (!_ctx.showAddModifica)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.task.modificheHistory.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.modificheHistory, (item, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                                class: "mb-1",
                                key: i
                            }, _toDisplayString(_ctx.$filters.date(item.date, null, true)) + " - " + _toDisplayString(item.text), 1));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true),
                _hoisted_13
            ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("textarea", {
                        class: "form-control",
                        ref: "input",
                        onInput: _cache[3] || (_cache[3] = ev => _ctx.modificaText = ev.target.value),
                        ".value": _ctx.modificaText,
                        rows: "4"
                    }, null, 40, _hoisted_17)
                ]),
                _createElementVNode("div", _hoisted_18, [
                    (_ctx.savingModifica)
                        ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-green",
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => (_ctx.saveModifica && _ctx.saveModifica(...args)))
                        }, "Salva"))
                ])
            ])),
        _hoisted_19,
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-checkbox ml-2", { checked: _ctx.task.showDeliveryAttachments }]),
                    onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.task.showDeliveryAttachments = !_ctx.task.showDeliveryAttachments))
                }, null, 2)
            ])
        ]),
        (_ctx.customer && (_ctx.customer.isAccountPadre || _ctx.customer.clienteParentIdentifier))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_24,
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _withDirectives(_createElementVNode("select", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.taskOwner) = $event)),
                        onChange: _cache[7] || (_cache[7] =
                            //@ts-ignore
                            (...args) => (_ctx.setNewOwner && _ctx.setNewOwner(...args)))
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.familyMembers, (item, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: i,
                                value: item
                            }, _toDisplayString(item.name), 9, _hoisted_28));
                        }), 128))
                    ], 544), [
                        [_vModelSelect, _ctx.taskOwner]
                    ])
                ])
            ], 64))
            : _createCommentVNode("", true),
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
            (_ctx.deleting)
                ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-sm btn-danger",
                    type: "button",
                    onClick: _cache[8] || (_cache[8] =
                        //@ts-ignore
                        (...args) => (_ctx.removeTask && _ctx.removeTask(...args)))
                }, " Elimina e restituisci crediti "))
        ])
    ]));
}
